import React from 'react';
import authRoles from 'app/auth/authRoles';
import Livestreaming from './Livestreaming';

const PackagesConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/livestreaming/:slug',
			element: (
				<React.Suspense fallback={<>...</>}>
					<Livestreaming />
				</React.Suspense>
			),
		},
	],
	auth: authRoles.productOwner,
};

export default PackagesConfig;
